export default __webpack_public_path__ + "static/media/71.3ca154ab.jpg";